import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class AuthAPI {

  callLogInApi(loginReq) {
    return api.post(API_URLS.URL.login, loginReq);
  }
  
  callForgotPasswordApi(loginReq) {
    return api.post(API_URLS.URL.forgotPassword, loginReq);
  }
  
  callResetPasswordApi(loginReq) {
    return api.post(API_URLS.URL.resetPassword, loginReq);
  }
  callRefreshToken(refreshToken) {
    return api.post(API_URLS.URL.refreshToken+"?refresh_token="+refreshToken);
  }
}
